import { useEffect, useState } from 'react';
import { worldMobileViewerHref, worldViewerHref } from '@viewer/viewerRoute';

interface WorldEntry {
  id: string;
  title: string;
  description?: string;
}

interface WorldsManifest {
  worlds: WorldEntry[];
}

export function WorldIndexApp() {
  const [worlds, setWorlds] = useState<WorldEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await fetch('/worlds/manifest.json', { cache: 'no-store' });
        if (!res.ok) throw new Error(`manifest ${res.status}`);
        const manifest = (await res.json()) as WorldsManifest;
        if (!cancelled) setWorlds(manifest.worlds ?? []);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load worlds');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="world-index">
      <header className="world-index-header">
        <h1>3DGS Worlds</h1>
        <p>Pick a scene to open the Go Into It viewer (~72 MB streamed splats).</p>
      </header>

      {error ? <p className="world-index-error">{error}</p> : null}

      <ul className="world-index-list">
        {(worlds ?? []).map((world) => (
          <li key={world.id} className="world-index-card">
            <div className="world-index-card-body">
              <h2>{world.title}</h2>
              {world.description ? <p>{world.description}</p> : null}
            </div>
            <div
              className={
                world.id === 'lair'
                  ? 'world-index-actions world-index-actions--stacked'
                  : 'world-index-actions'
              }
            >
              {world.id === 'lair' ? (
                <a
                  className="world-index-btn world-index-btn--primary"
                  href={worldMobileViewerHref(world.id)}
                >
                  Mobile fullscreen
                </a>
              ) : null}
              <a className="world-index-btn" href={worldViewerHref(world.id)}>
                Open world
              </a>
            </div>
          </li>
        ))}
      </ul>

      {!worlds && !error ? <p className="world-index-loading">Loading worlds…</p> : null}
    </main>
  );
}
